export default {
  email: 'Электронная почта',
  name: 'Имя',
  phone: 'Телефон',
  phoneNumber: 'Номер телефона',
  encrypt: 'Все данные шифруются и передаются напрямую нашим специалистам',
  readyToSend: 'Готово к отправке',
  sendRequest: 'Отправить заявку',
  enterPhoneNumber: 'Введите номер телефона',
  next: 'Далее',
  enterEmail: 'Введите e-mail'
}
